import type { Locale } from '@change-corgi/config/locales';

import __json from '../config/press.json';

type CountryData =
	| string
	| Readonly<{
			url: string;
			localesOverrides?: Readonly<Record<Locale, string>>;
	  }>;

type DataFromJson = Readonly<Record<string, CountryData>>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
const data: DataFromJson = __json as any;

export function getPressUrl({ locale, countryCode }: { locale?: Locale; countryCode: string }): string | undefined {
	const countryConfig = data[countryCode];
	if (!countryConfig) {
		return undefined;
	}
	if (!(typeof countryConfig === 'object')) {
		return countryConfig;
	}
	if (!locale || !countryConfig.localesOverrides || !countryConfig.localesOverrides[locale]) {
		return countryConfig.url || undefined;
	}
	return countryConfig.localesOverrides[locale] || undefined;
}
